import React from 'react';
import { Route, Link } from 'react-router-dom';
import Modal from '../Common/Modal';
import Button from '../Common/Button';
import TransparentButton from '../Common/TransparentButton';
import EditIncomeForm from '../EditIncomeForm';
import s from './IncomeCards.scss';
import { formatMoney } from '../../../utils';
import { choices } from '../../../choices';
import DeleteIcon from '../../../assets/images/icons/trash-can-green.svg';
import EditIcon from '../../../assets/images/icons/Edit_1.svg';


export const isMonotributo = val => val === 'MS' || val === 'MO';

export const findTitle = (options, selected) => options.find(([title, value]) => value === selected)[0]

export const incomeType = choices.jobs.map(({ text, value }) => [text, value]);

export const incomeTypeStaff = choices.jobsStaff.map(({ text, value }) => [text, value]);

export const getCategory = incomeType => choices.jobs.find(job => job.value === incomeType).category.map(({ text, value }) => [text, value]);

export const seniority = [
    ['Menos de 1 año', 0],
    ['Entre 1 y 3 años', 1],
    ['Entre 3 y 5 años', 3],
    ['Más de 5 años', 5]
];

export const justify_incomes_options = [
    ['Si', true],
    ['No', false],
];

 class IncomeCards extends React.Component {

    state = {
        showModal: false,
        incomeToDelete: null,
    }

    openModal = (incomeToDelete) => {
        this.setState({
            showModal: true,
            incomeToDelete,
        })
    }

    closeModal = () => {
        this.setState({
            showModal: false,
            incomeToDelete: null,
        })
    }

    deleteIncome = () => {
        this.props.deleteIncome(this.state.incomeToDelete);
        this.closeModal();
    }


    render() {
        const { incomes, url, path, editIncome, userBorrower, is_staff, eliminar } = this.props
        const { showModal, incomeToDelete } = this.state;
        return (
            <div className={s.container}>
                {incomes.map((income, i) => (
                    <div key={income.number} className={s.card}>
                        <div className={s.incomeName}>{(userBorrower) ? userBorrower.first_name + ' '+ ' ' + userBorrower.last_name + ' (titular)' : ''}</div>
                        <div className={s.incomeInfo}>
                            <p className={s.currency}>$</p>
                            <p className={s.incomeMoney}>{formatMoney(income.income)}</p>
                            <p className={s.extraText}>por mes</p>
                        </div>
                        <div className={s.moreIncomeInfo}>
                            <p className={s.extraText}>como</p>
                            <p className={s.incomeType}>{findTitle(is_staff ? incomeTypeStaff : incomeType, income.income_type)} {isMonotributo(income.income_type) && income.category}</p>
                        </div>
                        <div className={s.options}>
                          <TransparentButton className={s.edit}><img className={s.editIcon} alt={"icono lapiz editar"} src={EditIcon}/><Link to={`${url}/editar/${income.number}`}>Editar</Link></TransparentButton>
                          {(incomes.length == 1) ? null : <button className={s.delete} onClick={() => this.openModal(income.number)}><img className={s.deleteIcon} src={DeleteIcon} alt={"icono tacho de basura borrar"} /></button>}
                        </div>
                    </div>
                ))}
                <Modal className={s.modal} showModal={showModal} closeModal={this.closeModal} closeButton={true} style={{ fontSize: '18px', maxWidth: '30%', fontFamily: 'MuseoSans-100, sans-serif'}}>
                    <div className={s.titleModal}>¿Estás seguro de que querés eliminar este ingreso?</div>
                    <div className={s.buttonContainer}>
                        <Button className={s.cancelar} onClick={this.closeModal}>No</Button>
                        <Button className={s.eliminar} onClick={this.deleteIncome}>Sí</Button>
                    </div>
                </Modal>
                <Route
                    path={`${path}/editar/:id`}
                    render={(props) => (
                        <EditIncomeForm
                            income={incomes.find(income => income.number === Number(props.match.params.id))}
                            editIncome={editIncome}
                            redirectUrl={url}
                            is_staff={is_staff}
                            {...props}
                        />
                    )}
                />
            </div>
        );
    }
}

export default IncomeCards;
